//
//
//
//
//
//
//
//
//
//
//
//

import { Icon } from "vant";
import FlowSteps from "@/components/common_flowSteps.vue";
import InputList from "@/components/input_item";
import MyForm from "@/components/common_form";
import PageBtns from "@/components/common_pageBtns";
import memberStep from "@/components/newMemberStep";
export default {
  name: "",
  components: { FlowSteps, InputList, MyForm, PageBtns,memberStep },
  data() {
    return {
      stepInfo: {
        curStep: 3,
        color: "rgb(81,170,56)",
        list: ["手机验证", "基本信息", "审核", "完成"]
      },
      flowConfig: {
        bg: "#fff",
        padding: "15px 40px",
        size: "15px",
        numberSize: "18px",
        textSize: "14px",
        textTop: "33px",
        lineWidth: "3px",
        list: [
          {  text: "手机验证", isDone: true },
          {  text: "基本信息", isDone: true },
          {  text: "审核", isDone: true },
          {  text: "完成", isDone: false }
        ]
      },
      btnConfig: {
        bottom:"80px",
        list: [
          {
            text: "查看审核进度",
            type: "primary",
            action: () => {
              this.$router.push("/register/AuditProgress");
            }
          },
          {
            text: "返回",
            type: "primary",
            action: () => {
              this.$router.go(-1);
            }
            // /MembershipRegistration"
          },
        ]
      }
    };
  },
  props: [],
  computed: {},
  created() {},
  methods: {
    onPickerConfirm(value) {
      this.formConfig.list[1].value = value;
      this.isPickerShow = false;
    }
  }
};
